import {
    ListingStatus,
    OrderStatus,
    PricingUnit,
    Product,
    OfferListingStatus,
    CustomOfferListingStatus,
    RFQStatus,
} from '@steelbuy/ts-shared';
import { FileUploadStatus } from '@steelbuy/ui-primitive';
import { SortCriteriaOption } from '../lib/search-results/SearchResults.enums';

export default {
    addressForm: {
        primaryTagLabel: 'Standardadresse',
        companyName: 'Name',
        addressLine1: 'Adresszeile 1',
        addressLine2: 'Adresszeile 2 (optional)',
        town: 'Ort',
        postcode: 'Postleitzahl',
        primaryAddressNotDeletable:
            'Sie können Ihre Standardadresse nicht löschen. Legen Sie zunächst eine andere Adresse als Standardadresse fest.',
        country: 'Land',
        phoneNumber: 'Telefonnummer (optional)',
        saveAddressButtonLabel: 'Speichern',
        setAsPrimary: 'Als Standardadresse festlegen.',
        updateAddressButtonLabel: 'Speichern',
        state: 'Zustand',
    },
    autoRenew: {
        autoRenewHeader: 'Automatische Verlängerung des Angebotes',
        autoRenewHelper:
            'Das Angebot wird automatisch verlängert, wenn es zum Ablaufdatum nicht verkauft wurde. Sollten hierzu Änderungen erforderlich sein, erhalten Sie vorab eine Benachrichtigung. Es erhöht die Sichtbarkeit des Eintrags und erweitert seine Reichweite für potenzielle Käufer.',
        autoRenewLabel: 'Automatische Verlängerung des Angebotes',
    },
    cardContentCheckoutAddresses: {
        listHeading: 'Abholadresse',
        notificationMessage: 'Bitte wählen Sie die Adresse, von der wir das Material abholen können.',
    },
    checkoutDeliveryAddress: {
        listHeading: 'Lieferadresse',
        notificationMessage: 'Bitte wählen Sie die Lieferadresse aus, an die wir das Material liefern sollen.',
    },
    common: {
        edit: 'Bearbeiten',
        delete: 'Löschen',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        back: 'Zurück',
        saveChanges: 'Speichern',
        remove: 'Entfernen',
        retry: 'Wiederholen',
        save: 'Speichern',
    },
    commonList: {
        loadMore: 'Mehr laden',
        noListCaption: 'Keine Ergebnisse gefunden',
        buyNow: 'Jetzt kaufen',
        addToCart: 'Hinzufügen',
        addedToCart: 'Hinzugefügt',
        new: 'Neu',
    },
    confirmSelectionModal: {
        confirmLabel: 'Weiter',
        header: 'Änderungen wirken sich auf Ihre Auswahl auf dem nächsten Bildschirm aus. Fortfahren?',
    },
    createListingTeaser: {
        attributeAge: 'Alter',
        attributeSku: 'Material-ID',
        expirationTime: 'Ablauf: ',
    },
    customPrompt: {
        discardButtonLabel: 'Änderungen verwerfen',
    },
    deleteDraftModal: {
        confirmButtonLabel: 'Entwurf löschen',
        textContent: 'Möchten Sie diesen Entwurf wirklich löschen?',
    },
    emailAddressForm: {
        emailLabel: 'E-Mail-Adresse',
        submitLabel: 'E-Mail-Adresse ändern',
        enterValidEmail: 'Geben Sie eine gültige E-Mail-Adresse ein',
        emailNotUpdated: 'E-Mail-Adresse wurde nicht aktualisiert',
    },
    fileInput: {
        showMoreLabel: 'Mehr anzeigen',
        showLessLabel: 'Weniger anzeigen',
        viewButton: 'Anzeigen',
        fileInputLabel: 'Bitte wählen Sie die Datei(en) zum Hochladen aus',
        filesUploaded: '{{uploadedCount}} von {{totalFiles}} hochgeladen',
        filesizeKB: '{{size}}KB',
        filesizeMB: '{{size}}MB',
        sizeAndStatus: '{{size}} - {{status}}',
        fileUploadStatus: {
            [FileUploadStatus.Uploading]: 'Hochladen',
            [FileUploadStatus.Error]: 'Fehler',
            [FileUploadStatus.Success]: 'Hochgeladen',
        },
    },
    login: {
        headerTitle: 'Login',
        errors: {
            usernameRequired: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
            passwordRequired: 'Passwort ist erforderlich',
            passwordFormatError:
                'Das Passwort darf nur Buchstaben, Zahlen und Sonderzeichen ohne Leerzeichen enthalten',
            passwordIncorrect: 'Ihre E-Mail-Adresse oder Ihr Passwort sind falsch.',
            serverError: 'Interner Serverfehler',
            temporaryPasswordExpired:
                'Das temporäre Passwort ist abgelaufen. Das temporäre Passwort läuft nach 24 Stunden ab und kann nur einmal verwendet werden.',
            timeoutError:
                'Ihre Sitzung ist abgelaufen. Bitte geben Sie Ihren Benutzernamen und Ihr temporäres Passwort erneut ein.',
            unauthorized: 'Sie sind nicht berechtigt, auf diese Seite zuzugreifen',
            rateLimit:
                'Sie haben das Limit für erfolglose Anmeldeversuche erreicht. Aus Sicherheitsgründen versuchen Sie es bitte erst in einer Stunde erneut. Sollten Sie Ihr Passwort vergessen haben, nutzen Sie die Option „Passwort vergessen“.',
            validationError: 'Fehler: Es ist ein Fehler aufgetreten.',
            invalidEmail: 'Ungültige E-Mail',
        },
        forgotPassword: 'Passwort vergessen?',
        usernameLabel: 'E-Mail',
        passwordLabel: 'Passwort',
        usernamePlaceholder: 'Geben Sie die E-Mail-Adresse ein',
        passwordPlaceholder: 'Passwort eingeben',
        submitLabel: 'Login',
        challengeRespond: {
            forcePasswordChange: {
                header: 'Neues Passwort erstellen',
                subheading: {
                    welcome: 'Willkommen, {{username}}. Bitte vergeben Sie ein neues Passwort für Ihr Konto.',
                    p2: 'Verwenden Sie mindestens 12 Zeichen — länger ist besser.',
                    p3: 'Verwenden Sie am besten eine Phrase aus mehreren einprägsamen Wörtern.',
                },
                successNotification: 'Ihr Passwort wurde geändert. Melden Sie sich an, um fortzufahren.',
            },
            softwareTokenMfa: {
                header: 'Zwei-Faktor-Authentifizierung',
                subheading:
                    'Für zusätzliche Sicherheit wurde in Ihrem Konto die Zwei-Faktor-Authentifizierung (2FA) aktiviert.',
                info: 'Geben Sie den von der App generierten Authentifizierungscode ein.',
                sixDigitCodeLabel: '6-stelliger Code',
                sixDigitCodePlaceholder: '6-stelliger Verifizierungscode',
                submitLabel: 'Einreichen',
                continueLabel: 'Weiter',
            },
            mfaSetup: {
                header: 'Zwei-Faktor-Authentifizierung',
                subheading:
                    'Für zusätzliche Sicherheit wurde in Ihrem Konto die Zwei-Faktor-Authentifizierung (2FA) aktiviert.',
                instructions: {
                    downloadAndInstall:
                        'Einfach Authentifizierungs-App (z. B. Google Authenticator) herunterladen, installieren und damit den QR-Code scannen.',
                    scanQRCode: 'Scannen Sie den QR-Code.',
                    verifyAuthCode: 'Geben Sie anschließend den von der App generierten Authentifizierungscode ein.',
                },
                validationFailed: 'Die Validierung ist fehlgeschlagen',
                codeMismatch: 'Nichtübereinstimmung des Codes',
                genericError: 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
            },
        },
        tempPasswordEmailSent: 'Die Willkommens-E-Mail wurde erneut gesendet {{username}}',
        newAccount: {
            label: 'Benötigen Sie ein Konto?',
            link: 'Fordern Sie ein Konto an',
        },
        resetPassword: {
            header: 'Passwort zurücksetzen',
            tokenExpired:
                'Der Link ist abgelaufen. Der Link zur E-Mail-Bestätigung läuft nach 24 Stunden ab und kann nur einmal verwendet werden.',
            resendEmail: 'E-Mail erneut senden',
            successNotification: 'Ihr Passwort wurde geändert. Melden Sie sich erneut an, um fortzufahren.',
            expiredPassword: {
                expiredTokenError: {
                    header: 'Der Link zum Zurücksetzen des Passworts ist abgelaufen',
                    body: 'Der E-Mail-Bestätigungslink läuft nach 24 Stunden ab und kann nur einmal verwendet werden',
                },
                unknownTokenError: {
                    header: 'Ungültiger Passwort-Link',
                    body: 'Der Passwort-Link ist ungültig. Bitte senden Sie den Link erneut und versuchen Sie es erneut',
                },
                submitLabel: 'Link zum Zurücksetzen des Passworts erneut senden',
            },
        },
        createNewPassword: {
            header: 'Neues Passwort erstellen',
            description: 'Willkommen, {{email}}, bitte erstellen Sie ein neues Passwort für Ihr Konto.',
            successNotification: 'Das Passwort wurde erfolgreich erstellt. Melden Sie sich an und fahren Sie fort.',
            expiredPassword: {
                expiredTokenError: {
                    header: 'Aktivierungslink abgelaufen',
                    body: 'Der Aktivierungslink läuft nach 48 Stunden ab und kann nur einmal verwendet werden.',
                },
                submitLabel: 'E-Mail erneut senden',
            },
            tokenExpired:
                'Aktivierungslink abgelaufen. Der Aktivierungslink läuft nach 48 Stunden ab und kann nur einmal verwendet werden.',
        },
        backToLogin: 'Zurück zum Anmelden',
        passwordChangedNotification: 'Ihr Passwort wurde geändert.\nEinloggen und fortfahren.',
        passwordAlreadyCreated: 'Der Benutzer hat bereits ein Passwort für dieses Konto erstellt',
    },
    listingBuyerDetailsPrice: {
        cardTitle: 'Gewicht und Preis',
        pricePerUnit: 'Preis pro {{pricingUnit}} (inkl. Lieferung)',
        totalExclVat: 'Gesamt (exkl. MwSt.)',
        totalExclDelivery: 'Gesamt (exkl. Lieferung)',
        totalInclDelivery: 'Gesamtpreis (inkl. Lieferung)',
        deliveredTotal: 'Gelieferter Gesamtpreis',
        pricePerUnitExclDelivery: 'Preis pro {{pricingUnit}}',
        total: 'Gesamt',
        loadingPrice: 'Laden',
    },
    cart: {
        subtotal: 'Zwischensummenwert',
        deliveredTotalPrice: 'Gelieferter Gesamtpreis',
        exclVat: '(exkl. MwSt.)',
        item_one: '({{count}} Artikel)',
        item_other: '({{count}} Artikel)',
        subtotalWeight: 'Zwischensummengewicht',
    },
    checkoutCart: {
        item_one: '{{count}} Artikel',
        item_other: '{{count}} Artikel',
    },
    cartModal: {
        pricePerUnit: 'pro {{pricingUnit}}, inkl. Lieferung',
    },
    listingDraftTeaser: {
        lastEdited: 'Zuletzt bearbeitet',
        draft: 'Entwurf',
    },
    listingSellerStatus: {
        [ListingStatus.DRAFT]: 'Entwurf',
        [ListingStatus.REVIEW_REQUIRED]: 'In Prüfung',
        [ListingStatus.REVIEW_REJECTED]: 'Abgelehnt',
        [ListingStatus.PUBLISHED]: 'Online',
        [ListingStatus.PURCHASED]: 'Verkauft',
        [ListingStatus.WITHDRAWN]: 'Zurückgezogen',
        [ListingStatus.EXPIRED]: 'Abgelaufen',
    },
    listingTeaser: {
        expiryDate: 'Läuft ab: {{expiryDate}}',
    },
    listingSellerTeaser: {
        today: 'Heute',
    },
    listingDetailsStatus: {
        header: {
            [ListingStatus.DRAFT]: 'Zuletzt gespeichert unter:',
            [ListingStatus.REVIEW_REQUIRED]: 'Zur Prüfung eingereicht am:',
            [ListingStatus.REVIEW_REJECTED]: 'Abgelehnt am:',
            [ListingStatus.PUBLISHED]: 'Online seit:',
            [ListingStatus.PURCHASED]: 'Zum Kauf aufgefordert bei:',
            [ListingStatus.WITHDRAWN]: 'Zurückgezogen am:',
            [ListingStatus.EXPIRED]: 'Abgelaufen am:',
        },
        expiredInfo:
            'Sie können dieses Angebot verlängern, wenn Sie ein neues Ablaufdatum festlegen, und bei Bedarf auch Ihren Preis anpassen. Anschließend können Sie den erneuerten Eintrag direkt auf dem Marktplatz veröffentlichen.',
    },
    listingDetailsExpiration: {
        title: 'Ablaufdatum',
        text: 'Das Angebot läuft ab am',
        bulkText: 'Angebote laufen ab am',
        autoRenewLabel: 'Automatische Verlängerung des Angebotes',
        autoRewewBulkLabel: 'Automatische Verlängerung von Angeboten',
        autoRenewEnabled: 'Aktiv',
        autoRenewDisabled: 'Deaktiviert',
        autoRenewToggleHelper:
            'Es erhöht die Sichtbarkeit des Eintrags und erweitert seine Reichweite für potenzielle Käufer.',
        autoRewewExpiryLabel: 'Neues Ablaufdatum nach automatischer Verlängerung',
    },
    expiryTimeSelection: {
        formItemHeader: 'Ablaufdatum des Eintrags',
        label: 'Das Ablaufdatum wir aktiviert, wenn Sie Ihr Angebot zur Prüfung einreichen. Für den entsprechenden Zeitraum stimmen Sie zu, Ihr Angebot exklusiv auf SteelBuy zu verkaufen.',
        selectDatePlaceholder: 'Wählen Sie das Ablaufdatum',
        selectTimePlaceholder: 'Zeit',
    },
    forgotPassword: {
        title: 'Passwort vergessen?',
        subheading:
            'Geben Sie unten Ihren Benutzernamen ein und wir senden Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts',
        submitLabel: 'Senden Sie eine E-Mail zum Zurücksetzen des Passworts',
        enterValidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    },
    passwordLinkSent: {
        title: 'Link zum Zurücksetzen des Passworts gesendet',
        subheading: 'Wenn Sie auf ein Problem stoßen, wenden Sie sich bitte an den Kundendienst.',
        notification:
            'Wenn ein Konto vorhanden ist für {{username}} Wir senden Ihnen Anweisungen zum Zurücksetzen Ihres Passworts.',
        backToSignIn: 'Zurück zur Anmeldung',
    },
    listingDetailsViews: {
        header: 'Leistung',
        numberOfViews: 'Anzahl der Ansichten',
    },
    listingDetailsMaterial: {
        detailsTitle: 'Einzelheiten',
        skuLabel: 'Ihre Material-ID',
    },
    listingTeaserContainer: {
        buyerPurchaseOrderNumber: 'Ihre Bestellnummer:',
        steelBuyPurchaseOrderNumber: 'SteelBuy-Bestellnummer:',
        sellerMaterialId: 'Ihre Material-ID:',
        negotiationReference: 'Verhandlungsreferenznummer: ',
        materialLocation: 'Materialstandort:',
        weight: 'Gewicht:',
        origin: 'Herkunft:',
        age: 'Alter:',
        prime: 'Erstklassig',
        nonPrime: 'Nicht erstklassig',
        fileName: 'Dateiname:',
    },
    listingTeaserOfferBadge: {
        status: {
            [OfferListingStatus.ACCEPTED]: 'Akzeptiert',
            [OfferListingStatus.AWAITING_SELLER]: 'Warten auf die Antwort des Verkäufers',
            [OfferListingStatus.AWAITING_BUYER]: 'Warten auf Antwort des Käufers',
            [OfferListingStatus.REJECTED]: 'Abgelehnt',
            [OfferListingStatus.EXPIRED]: 'Abgelaufen',
            [OfferListingStatus.WITHDRAWN]: 'Zurückgezogen',
            [OfferListingStatus.CANCELLED]: 'Abgesagt',
            [CustomOfferListingStatus.NO_SUCCESSFUL_OFFERS]: 'Keine erfolgreichen Angebote',
            [OfferListingStatus.PURCHASED]: 'Verkauft',
        },
        awaitingYourResponse: 'Warten auf Ihre Antwort',
        outbid: 'Überbieten',
        numberOffersHasLabel: 'Dieses Angebot hat {{numberOffers}} Angebote',
        numberOffersHadLabel: 'Es gab {{numberOffers}} Preisvorschläge zu diesem Angebot',
        numberOffersHasOneLabel: 'Dieses Angebot hat {{numberOffers}} Angebot',
        offerInProgress: 'Angebot in Bearbeitung',
    },
    rfqTeaserStatusBadge: {
        status: {
            [RFQStatus.REJECTED]: 'Abgelehnt',
            [RFQStatus.LIVE]: 'Online',
            [RFQStatus.WITHDRAWN]: 'Zurückgezogen',
            [RFQStatus.EXPIRED]: 'Abgelaufen',
            [RFQStatus.UNDER_REVIEW]: 'In Prüfung',
        },
    },
    rfqBuyerTeaser: {
        expiryDate: 'Läuft ab: {{-expiryDate}}',
    },
    rfqForm: {
        definition: {
            description: 'Sie können eine oder mehrere Definitionen gleichzeitig auswählen.',
        },
        plateType: {
            description: 'Sie können einen oder mehrere Typen gleichzeitig auswählen.',
        },
    },
    rfqDraftTeaser: {
        lastEdited: 'Zuletzt bearbeitet',
        infoFieldsMissing_one: 'Informationen in {{ count }} Feld fehlt',
        infoFieldsMissing_other: 'Informationen in {{ count }} Felder fehlen',
        draft: 'Entwurf',
    },
    listingTeaserPrice: {
        detailsButton: 'Einzelheiten',
        offerRange: 'Angebotsbereich:',
    },
    marketingBannerSteelbuyPromise: {
        header: 'Unser SteelBuy Versprechen an Sie',
        promiseSeller: 'Sicherheit – Sie handeln ausschließlich mit geprüften Kunden',
        promiseProcess: 'Full Service – Wir übernehmen Abholung und Lieferung',
    },
    inputCharacterCount: {
        inputCharacterRemaining_one: 'Verbleibendes Zeichen: {{remainingCharactersCount}}',
        inputCharacterRemaining_other: 'Verbleibende Zeichen: {{remainingCharactersCount}}',
    },
    materialAdditionalComment: {
        description: 'Ergänzen Sie Ihre Materialanfrage bei Bedarf durch zusätzliche Informationen für Verkäufer.',
        placeholder:
            'Bitte geben Sie hier zusätzliche Informationen ein, z.B. zur gewünschten Qualität der Materialien',
        label: 'Kommentare (optional)',
        header: 'Zusätzliche Kommentare',
        maxCharacterError: 'Maximale Zeichenanzahl überschritten.',
    },
    materialDimensionSelection: {
        toleranceThicknessLabel: 'Toleranzdicke',
    },
    materialTestCert: {
        header: 'Prüfzeugnis/Brief',
        uploadNewFile: 'Neue Datei hochladen',
        testCertToFollow: 'Prüfzeugnis/Konformitätsbescheinigung folgen',
        requestCertificate: 'Zertifikat anfordern',
        requestCertificateSuccess: 'Ihre Anfrage für ein Testzertifikat wurde erfolgreich an den Verkäufer gesendet.',
        requestCertificateError: 'Ihre Testzertifikat-Anfrage konnte nicht gesendet werden.',
    },
    materialQualitySelection: {
        descriptionLabel: 'Ausführliche Beschreibung',
        descriptionPrimeLabel: 'Detaillierte Beschreibung (optional)',
        descriptionPlaceholder:
            'Bitte beschreiben Sie den genauen Materialzustand, damit Käufer die Qualität beurteilen können.',
        descriptionPrimePlaceholder:
            'Bitte geben Sie hier zusätzliche Informationen an, z. B. das Werk oder den Ursprung des Materials, wenn ein Konformitätsschreiben hochgeladen wird.',
        pictureUploadLabel: 'Bild hochladen (optional)',
        testCertificateLabel: 'Werkszertifizierung hochladen',
        testCertificateLabelOptional: 'Werkszertifizierung hochladen (optional)',
    },
    materialSelection: {
        placeholder: 'Wählen Sie eine Option',
        otherLabel: 'Andere',
    },
    materialInput: {
        placeholder: 'Option auswählen',
    },
    gaugeSelection: {
        label: 'Messgerät (Dicke)',
    },
    materialOriginSelection: {
        materialOriginSelection: 'West-Europa: EU-Länder, Vereinigtes Königreich, Schweiz, Norwegen',
    },
    materialWeightInput: {
        formItemHeader: 'Gewicht',
        formItemHeaderTheoretical: 'Theoretisches Gewicht',
        weightInputLabel: 'Gesamtgewicht',
        weightInputLabelTheoretical:
            'Bitte beachten Sie, dass Sie diesen Artikel nur auf Basis des theoretischen Gewichts verkaufen.',
        theoreticalWeightNotification:
            'Bitte geben Sie im vorherigen Schritt alle Abmessungen und die Anzahl der Artikel ein, um das theoretische Gesamtgewicht zu berechnen.',
    },
    myAlertsDeletionModal: {
        confirmButtonLabel: 'Bestätigen',
        textContent: 'Möchten Sie diesen Suchauftrag wirklich löschen?',
    },
    makeAnOfferModal: {
        makeAnOffer: 'Preisvorschlag abgeben',
        reviewOffer: 'Ihr Preisvorschlag im Überblick',
        submitOffer: 'Preisvorschlag abgeben',
        review: 'Weiter',
        pricelabel: 'Originalpreis pro {{pricingUnit}}',
        proposedPrice: 'Ihr vorgeschlagener Preis pro {{pricingUnit}}',
        creditLimitExceed: 'Der von Ihnen eingegebene Betrag überschreitet Ihr Kreditlimit.',
        minimumPriceError: 'Bitte geben Sie einen höheren Betrag ein, der dem Marktwert entspricht.',
        priceExceed: 'Der von Ihnen eingegebene Betrag ist höher als der Originalpreis.',
        infoMsg: 'Sie erhalten innerhalb von 24 Stunden ein Update vom Verkäufer.',
        reviewPricingUnit: {
            [PricingUnit.TON]: {
                label: 'Gewicht',
            },
            [PricingUnit.KILOGRAM]: {
                label: 'Gewicht',
            },
            [PricingUnit.SHEET]: {
                label: 'Artikel',
            },
            [PricingUnit.PLATE]: {
                label: 'Artikel',
            },
            [PricingUnit.TREAD]: {
                label: 'Artikel',
            },
            [PricingUnit.CWT]: {
                label: 'Gewicht',
            },
            [PricingUnit.LB]: {
                label: 'Gewicht',
            },
        },
        total: 'Gesamt',
        totalExcludingDelivery: 'Gesamt (ohne Lieferung)',
        failedToSubmitOffer: 'Angebot konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.',
        existingOffer:
            'Das Angebot kann nicht eingereicht werden, da Sie bereits ein aktives Angebot für diesen Eintrag haben.',
    },
    myAlertsEmptyState: {
        description:
            'Erstellen Sie Benachrichtigungen mit Ihren Suchkriterien, indem Sie nach dem benötigten Material suchen. Wir benachrichtigen Sie dann regelmäßig über passende Ergebnisse.',
        searchButtonLabel: 'Neue Suche starten',
        caption: 'Keine aktiven Warnungen',
    },
    myAlertsList: {
        alertSettingsButtonLabel: 'Einstellungen',
        newResultsSeparatorHeader_zero: 'Keine neuen Ergebnisse (letzte 24 Stunden)',
        newResultsSeparatorHeader_one: '1 Neues Ergebnis (letzte 24 Stunden)',
        newResultsSeparatorHeader_other: '{{count}} Neue Ergebnisse (letzte 24 Stunden)',
        searchSummaryNewResults: '{{value}} neu',
        urgent: 'Dringend',
    },
    myAlertsNeedMore: {
        caption: 'Derzeit gibt es keine Ergebnisse, die Ihren Kriterien entsprechen.',
        description: 'Wir benachrichtigen Sie per E-Mail, sobald das richtige Produkt bei SteelBuy verfügbar ist.',
    },
    myAlertsQna: {
        header: 'Fragen und Antworten',
        items: {
            howDoesAnAlertWork: {
                label: 'Wie funktionieren Benachrichtigungen?',
                content:
                    'Automatisieren Sie Ihre Materialsuche, indem Sie Suchaufträge oder Materialanfragen anlegen. Sobald passende Angebote online gehen, senden wir Ihnen sofort eine Benachrichtigung per E-Mail. Unter „Meine Benachrichtigungen“ können Sie Ihre Suchaufträge und Materialanfragen sowie die entsprechenden Benachrichtigungsoptionen verwalten.',
            },
            howDoUrgentRequestsWork: {
                label: 'Wie funktionieren Materialanfragen?',
                content:
                    'Beschleunigen Sie Ihre Materialsuche, indem Sie eine Materialanfrage stellen, die es Verkäufern ermöglicht, passende Angebote zu erstellen. Sobald diese online sind, informieren wir Sie sofort per E-Mail.',
            },
            howDoNotificationsWork: {
                label: 'Wie oft werde ich benachrichtigt?',
                content:
                    'Aktuell erhalten Sie jedes Mal eine E-Mail, wenn ein neues Angebot für das von Ihnen gesuchte Material online geht. In den Benachrichtigungseinstellungen können Sie die gewünschte Benachrichtigungsfrequenz einstellen.',
            },
            howToBestUseAlerts: {
                label: 'Wie nutzt man Benachrichtigungen am besten?',
                content:
                    'Aktivieren Sie Benachrichtigungen für Materialien, die Sie häufig benötigen oder wenn keine Suchergebnisse vorliegen. So müssen Sie die Suche nicht immer wieder neu konfigurieren und wir können Sie benachrichtigen, sobald neue Angebote erscheinen.',
            },
            howToMuteOrDeleteAlerts: {
                label: 'Wie kann ich Benachrichtigungen stummschalten?',
                content:
                    'Sie können die Benachrichtigungen für Suchaufträge und Materialanfragen in den Einstellungen unter "Meine Benachrichtigungen" stummschalten oder löschen.',
            },
        },
    },
    numberOfItemsInput: {
        itemLabel: {
            [Product.SHEET]: 'Die Gesamtzahl der Bleche.',
            [Product.PLATE]: 'Die Gesamtzahl der Platten.',
            [Product.TREAD]: 'Die Gesamtzahl der Riffelbleche.',
            [Product.FLOOR]: 'Die Gesamtzahl der Bodenplatten.',
        },
    },
    listingDraft: {
        attributeSku: 'Ihre Material-ID',
        attributeWeight: 'Gewicht',
        attributePrice: 'Preis',
        attributeExpiry: 'Ablauf',
        attributeCertificate: 'Werkszertifizierung',
    },
    numberOfItemsLabel: {
        label: {
            [Product.SHEET]: 'Anzahl der Bleche',
            [Product.PLATE]: 'Anzahl der Platten',
            [Product.TREAD]: 'Anzahl der Riffelbleche',
            [Product.FLOOR]: 'Anzahl der Bodenplatten',
        },
        valueWithLabel: {
            SHEET_zero: '{{count}} Bleche',
            SHEET_one: '1 Blech',
            SHEET_other: '{{count}} Bleche',
            PLATE_zero: '{{count}} Teller',
            PLATE_one: '1 Teller',
            PLATE_other: '{{count}} Teller',
            TREAD_zero: '{{count}} Teller',
            TREAD_one: '1 Teller',
            TREAD_other: '{{count}} Teller',
            FLOOR_zero: '{{count}} Teller',
            FLOOR_one: '1 Teller',
            FLOOR_other: '{{count}} Teller',
        },
        labelShort: {
            [Product.SHEET]: 'Anzahl der Bleche:',
            [Product.PLATE]: 'Anzahl Teller:',
            [Product.TREAD]: 'Anzahl Riffelbleche:',
            [Product.FLOOR]: 'Anzahl Bodenplatten:',
        },
    },
    listingSkuInput: {
        inputHeader: 'Ihre Material-ID',
    },
    orderStatus: {
        [OrderStatus.PROCESSING]: 'Bestellung in Bearbeitung',
        [OrderStatus.FREIGHT_BOOKED]: 'Fracht gebucht',
        [OrderStatus.SHIPPING]: 'Versand',
        [OrderStatus.DELIVERED]: 'Geliefert',
    },
    permissionInformation: {
        basic: {
            searchListing: 'Produkte suchen',
            alerts: 'Suchaufträge einrichten',
            drafts: 'Angebotsentwürfe erstellen',
        },
        seller: {
            submitListing: 'Angebote einreichen',
            editRejectedListing: 'Abgelehnte Angebote bearbeiten',
            renewListing: 'Überarbeitete Angebote veröffentlichen',
        },
        buyer: {
            purchaseProduct: 'Produkte kaufen',
        },
        manager: {
            editOrganisation: 'Unternehmensdaten bearbeiten',
            user: 'Benutzer hinzufügen und Berechtigungen bearbeiten',
            creditLineInformation: 'Kreditinformationen des Unternehmens einsehen',
        },
    },
    searchResults: {
        dataHeader: {
            alternativeResultsLabel: 'Alternative Ergebnisse',
            totalResultsLabel_zero: 'Keine Ergebnisse',
            totalResultsLabel_one: '1 Ergebnis',
            totalResultsLabel_other: '{{count}} Ergebnisse',
        },
    },
    searchResultsSorting: {
        inputTitle: 'Sortieren nach',
        options: {
            [SortCriteriaOption.RELEVANCE]: 'Relevanz',
            [SortCriteriaOption.EXPIRES_AT_DESCENDING]: 'Ablaufdatum',
            [SortCriteriaOption.EXPIRES_AT_ASCENDING]: 'Ablaufdatum',
            [SortCriteriaOption.WEIGHT_ASCENDING]: 'Gewicht',
            [SortCriteriaOption.WEIGHT_DESCENDING]: 'Gewicht',
            [SortCriteriaOption.PRICE_ASCENDING]: 'Preis',
            [SortCriteriaOption.PRICE_DESCENDING]: 'Preis',
            [SortCriteriaOption.WIDTH_DESCENDING]: 'Breite',
            [SortCriteriaOption.WIDTH_ASCENDING]: 'Breite',
        },
        placeholderText: 'Wählen Sie eine Option',
    },
    searchResultsTable: {
        newResultsSeparator_zero: 'Keine neuen Ergebnisse (letzte 24 Stunden)',
        newResultsSeparator_one: '1 Neues Ergebnis (letzte 24 Stunden)',
        newResultsSeparator_other: '{{count}} Neue Ergebnisse (letzte 24 Stunden)',
        alternativeResultsSeparator: 'Alternative Ergebnisse',
    },
    sellingPriceInput: {
        formItemHeader: 'Ihr Verkaufspreis pro {{pricingUnit}}',
        inputLabel: 'Diesen Betrag, erhalten Sie, wenn Ihr Material auf SteelBuy verkauft wird (exkl. MwSt.).',
    },
    setPassword: {
        passwordCriteria: {
            minChars: 'Mindestens 12 Zeichen verwenden',
            specialChars: 'Ein Sonderzeichen',
            number: 'Eine Zahl',
            lowerCase: 'Ein Kleinbuchstabe',
            upperCase: 'Ein Großbuchstabe',
            matching: 'Passwörter müssen übereinstimmen',
            fieldRequired: 'Dieses Feld ist erforderlich',
        },
        incorrectPassword: 'Falsches Passwort',
        passwordsMatch: 'Passwörter stimmen überein',
        password: 'Passwort',
        newPassword: 'Neues Passwort',
        currentPassword: 'Aktuelles Passwort',
        retypePassword: 'Neues Passwort wiederholen',
        submit: 'Passwort zurücksetzen',
        setPassword: 'Passwort festlegen',
        enterPassword: 'Passwort eingeben',
        enterNewPassword: 'Geben Sie das neue Passwort ein',
        enterRetypePassword: 'Neues Passwort wiederholen',
        updatePassword: 'Passwort ändern',
        enterCurrentPassword: 'Geben Sie das aktuelle Passwort ein',
    },
    validation: {
        requiredField: 'Dieses Feld ist erforderlich.',
        numberValue: 'Wert ist keine Zahl.',
        numberMinValue: 'Bitte geben Sie eine höhere Zahl ein.',
        numberMaxValue: 'Bitte geben Sie eine niedrigere Zahl ein',
        letterValue: 'Es sind nur Buchstaben erlaubt.',
        fileItemSizeError: 'Datei muss kleiner sein als {{sizeLimitInMegabytes}}MB',
        unsupporttedFileType: 'Nicht unterstützter Dateityp',
        numberLargerThan: 'Muss größer sein als {{min}}.',
        mustBeLessThan: 'Muss kleiner sein als der Maximalwert.',
        mustBeGreaterThan: 'Muss größer sein als der Minimalwert.',
        required: 'Erforderlich',
    },
};
